import React from 'react';

import { UploadedFile } from 'types';

import { styled } from '../theme';
import Avatar, { AvatarSize, AvatarType } from './Avatar';
import Button from './Button';
import FileUploader from './FileUploader';

const Container = styled('div')({
    position: 'relative',
});

const UploadButton = styled(Button)(({ theme }) => ({
    minWidth: 40,
    minHeight: 20,
    padding: '6px 12px',
    height: 'auto',
    position: 'absolute',
    bottom: 5,
    left: 5,
    fontSize: '1.2rem',

    background: theme.color.secondary1,
    border: '1px solid ' + theme.color.secondary2,
    color: theme.color.secondaryText,
    svg: {
        color: theme.color.secondary1,
    },
    ':hover': {
        background: theme.color.secondary2,
        color: theme.color.secondaryText,
        svg: {
            color: theme.color.secondary1,
        },
    },
    ':active': {
        background: theme.color.secondary2,
        color: theme.color.secondaryText,
        svg: {
            color: theme.color.secondary1,
        },
    },
}));

const Input = styled('input')(({ theme }) => ({
    cursor: 'inherit',
    display: 'block',
    filter: 'alpha(opacity=0)',
    minHeight: '100%',
    minWidth: '100%',
    opacity: 0,
    position: 'absolute',
    right: 0,
    textAlign: 'right',
    top: 0,
}));

type Props = {
    name: string;
    value: string;
    type: AvatarType;
    size?: AvatarSize;
    onChange: (target: object) => void;
    uploadFileApiRequest: ({ file, onProgress, cancelController }) => Promise<UploadedFile>;
    getUploadedFilePreviewUrl: (uploadedFileId: number) => Promise<string>;
};

type State = {
    src: string;
};

class UploadAvatarInput extends React.PureComponent<Props, State> {
    state = {
        src: this.props.value,
    };

    handleChange = (file: UploadedFile) => {
        const { getUploadedFilePreviewUrl } = this.props;

        getUploadedFilePreviewUrl(file.id).then((src) => this.setState({ src }));

        this.props.onChange({
            target: {
                name: this.props.name,
                value: file.url,
            },
        });
    };

    render() {
        const { src } = this.state;
        const { uploadFileApiRequest, type, size = 'big' } = this.props;

        return (
            <FileUploader apiRequest={uploadFileApiRequest} onUploadSuccess={this.handleChange}>
                {({ fileInputRef, handleFileChange }) => (
                    <Container>
                        <Avatar src={src} size={size} shape="square" type={type} />

                        <UploadButton
                            value="Edit"
                            color="custom"
                            onChange={(e) => e.preventDefault()}
                        >
                            {'Edit'}
                            <Input
                                ref={fileInputRef}
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                        </UploadButton>
                    </Container>
                )}
            </FileUploader>
        );
    }
}

export default UploadAvatarInput;
